import {ResolutionResponse as Base} from '@mintdata-wsp/common/controllers/network/generated/responses/ResolutionResponse';
import {Bundle} from '@mintdata-wsp/common/controllers/network/extended/responses/Bundle';

export class ResolutionResponse extends Base
{
    public readonly bundles:Bundle[];

    constructor(json:any)
    {
        super(json);

        this.bundles = [];

        for( let i = 0, length = (json['bundles'] || []).length; i < length; i++ )
        {
            this.bundles.push(new Bundle(json['bundles'][i]));
        }
    }
}
